"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_ANSI = void 0;
exports.STANDARD_ANSI = [
    'white',
    'black',
    'blue',
    'yellow',
    'green',
    'red',
    'magenta',
    'cyan',
    'gray',
    'blackBright',
    'redBright',
    'greenBright',
    'yellowBright',
    'blueBright',
    'magentaBright',
    'cyanBright',
    'whiteBright',
    'bgBlack',
    'bgRed',
    'bgGreen',
    'bgYellow',
    'bgBlue',
    'bgMagenta',
    'bgCyan',
    'bgWhite',
    'bgGray',
    'bgBlackBright',
    'bgRedBright',
    'bgGreenBright',
    'bgYellowBright',
    'bgBlueBright',
    'bgMagentaBright',
    'bgCyanBright',
    'bgWhiteBright',
    'bold',
    'underline',
    'dim',
    'italic',
    'strikethrough',
];
